import { SvgIcon, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";

export default function ConcentrixSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    return (
        <SvgIcon
            viewBox="0 0 1572 1571"
            sx={{ width: 24, height: 24, fill: "none", ...sx }}
        >
            <g fillRule="evenodd">
                <path
                    d="M0 785.5C0 351.683 351.907 0 786.005 0 1220.11 0 1572 351.683 1572 785.5S1220.11 1571 786.005 1571C351.907 1571 0 1219.317 0 785.5z"
                    fill="#063f5e"
                />
                <path
                    d="M172.432 786c0-174.197 141.297-315.412 315.61-315.412h595.931c174.314 0 315.614 141.215 315.614 315.412s-141.3 315.412-315.614 315.412H488.041c-174.312 0-315.609-141.215-315.609-315.412z"
                    fill="#26e1cc"
                />
                <path
                    d="M768.36 785.5c0-174.47 141.301-315.912 315.613-315.912 174.314 0 315.614 141.443 315.614 315.912s-141.3 315.912-315.614 315.912c-174.312 0-315.613-141.443-315.613-315.912z"
                    fill="#fff"
                />
                <path
                    d="M1148.416 860.53c14.647-4.822 26.573-9.093 40.084-13.9 10.407 19.162 20.932 38.558 31.39 57.818-60.978 53.781-168.369 49.421-227.723-8.776-55.307-54.203-60.719-144.593-12.312-205.292 54.437-68.25 161.114-81.24 241.244-26.599-10.287 19.568-20.844 39.651-32.296 61.49-48.772-21.62-97.454-32.782-137.751 13.166-22.312 25.432-21.823 56.532-6.604 85.751 16.833 32.281 54.073 44.864 103.968 36.343z"
                    fill="#063f5e"
                />
            </g>
        </SvgIcon>
    );
}
